<button class="flex flex-row aic" (click)="onClick($event)" [type]="type" [tabindex]="tabIndex" [id]="id + '-btn'">
  <rx-icon [class.gray]="isDisabled" [name]="icon" class="flex flex-nosize" *ngIf="icon"></rx-icon>
  <div class="flex flex-row aic jcc" [id]="id + '-content'" [ngClass]="{ m0: !icon }">
    <ng-content></ng-content>
  </div>
</button>
